import { Sheet, Typography, Box, Stack } from '@mui/joy';
import { Info } from '@phosphor-icons/react';

// Инфо-блок для ПЛАТНЫХ пользователей: где что находится.
// Показывается в личном кабинете (главный экран) и в учебных планах.
// Текст пунктов — дословно как задал владелец, не переформулировать.
const LINK = { color: '#B84C31', fontWeight: 600, textDecoration: 'none' };

export default function AccessInfoBanner({ sx }) {
    return (
        <Sheet
            variant="soft"
            sx={{
                borderRadius: 'md',
                border: '1px solid rgba(218,119,86,0.35)',
                bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(218,119,86,0.08)' : '#FFF8F0',
                p: 2,
                ...sx,
            }}
        >
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                <Info size={18} color="#DA7756" weight="duotone" />
                <Typography level="title-sm" sx={{ color: '#B84C31' }}>
                    Где что находится
                </Typography>
            </Stack>
            <Box component="ol" sx={{ m: 0, pl: 2.5, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                <Typography component="li" level="body-sm" color="neutral">
                    Лекции на{' '}
                    <a href="https://apexmeded.ru" target="_blank" rel="noopener noreferrer" style={LINK}>apexmeded.ru</a>
                </Typography>
                <Typography component="li" level="body-sm" color="neutral">
                    Тесты и задачи — на <b>apexqbank.ru</b>
                </Typography>
                <Typography component="li" level="body-sm" color="neutral">
                    Если есть вопросы — пишите в{' '}
                    <a href="https://t.me/ashurovmed" target="_blank" rel="noopener noreferrer" style={LINK}>личные сообщения ТГ канала</a>
                </Typography>
            </Box>
        </Sheet>
    );
}
